import { apiUrls } from '../../utils/api/api-urls';
import REQUEST from '../../utils/services';

const { AOV: { getAOV } } = apiUrls;

export const AOV_SUCCESS = 'AOV_SUCCESS';
export const AOV_LOADING = 'AOV_LOADING';

export const getAOVData = ({ from, to, vendor }) => async (dispatch) => {
    try {
        if (vendor) {
            const requestData = {
                ...getAOV,
                url: getAOV.url.replace('{from}', from).replace('{to}', to).replace('{{vendor}}', vendor)
            };
            const data = await REQUEST(requestData);
            dispatch({
                type: AOV_SUCCESS,
                data,
                vendor
            })
        }

    } catch (e) {

        dispatch({
            type: AOV_SUCCESS,
            data: {
                code: "",
                modal: null,
                notifications: null,
                paginationInfo: null
            },
            vendor
        })
    }


}

export const handleLoader = (isLoading, vendor) => (dispatch) => {
    if (vendor) {
        dispatch({
            type: AOV_LOADING,
            isLoading,
            vendor
        });
    }
}